import React, { useState, useEffect, useRef } from 'react';
import './SplitPanel.css';

export default function SplitPanel({ left, right, defaultWidth = 500, minWidth = 350, maxWidth = 700 }) {
  const [leftWidth, setLeftWidth] = useState(defaultWidth);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    // Load saved width from localStorage
    const saved = localStorage.getItem('splitPanelWidth');
    if (saved) {
      setLeftWidth(parseInt(saved, 10));
    }
  }, []);

  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleMouseMove = (e) => {
    if (!isDragging || !containerRef.current) return;

    const containerRect = containerRef.current.getBoundingClientRect();
    const newWidth = e.clientX - containerRect.left;

    if (newWidth >= minWidth && newWidth <= maxWidth) {
      setLeftWidth(newWidth);
      localStorage.setItem('splitPanelWidth', newWidth.toString());
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [isDragging]);

  return (
    <div ref={containerRef} className="split-panel">
      <div className="split-panel-left" style={{ width: `${leftWidth}px` }}>
        {left}
      </div>
      <div
        className="split-panel-divider"
        onMouseDown={handleMouseDown}
        style={{ cursor: isDragging ? 'col-resize' : 'col-resize' }}
      />
      <div className="split-panel-right" style={{ width: `calc(100% - ${leftWidth + 4}px)` }}>
        {right}
      </div>
    </div>
  );
}
